module.exports = __webpack_public_path__ + "img/mabang.a20db694.png";